var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layout-view" }, [
    _vm.isShow
      ? _c(
          "div",
          { staticClass: "layout" },
          [_c("Header"), _c("main", [_c("router-view")], 1), _c("Footer")],
          1
        )
      : _c(
          "div",
          { staticClass: "invite-activity" },
          [_c("InviteActivity")],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }